// WhatsApp click-to-chat helpers.
// Uses https://wa.me/<phone>?text=<url-encoded> — works on web + mobile without any API key.

export const DEFAULT_TEMPLATE =
  "Hi {customer_name}, this is {fe_name} from Sohom Fenster Tech. " +
  "Thanks for your interest in {building} ({lead_no}) at {locality}, {city}. " +
  "We'd love to share our brochure and set up a quick site visit — please let us know a convenient time.";

export const PLACEHOLDERS = [
  { key: "{customer_name}", hint: "Contact's name" },
  { key: "{building}", hint: "Building name (or 'the site')" },
  { key: "{lead_no}", hint: "Lead number (e.g. L-00006)" },
  { key: "{fe_name}", hint: "Your full name" },
  { key: "{city}", hint: "Lead city" },
  { key: "{locality}", hint: "Lead locality / area" },
];

/**
 * Resolve placeholders in a WhatsApp template against a lead, contact, and current user.
 * All placeholders are optional — missing values fall back to a sensible default.
 */
export function resolveTemplate(template, { lead, contact, user }) {
  const t = template && template.trim() ? template : DEFAULT_TEMPLATE;
  const values = {
    "{customer_name}": (contact && contact.name) || "there",
    "{building}": (lead && lead.building_name) || "the site",
    "{lead_no}": (lead && lead.lead_no) || "",
    "{fe_name}": (user && user.full_name) || "the Sohom team",
    "{city}": (lead && lead.city) || "",
    "{locality}": (lead && lead.locality) || "",
  };
  return Object.entries(values).reduce(
    (msg, [k, v]) => msg.split(k).join(v),
    t,
  );
}

/**
 * Normalize a phone number for wa.me:
 *   - strips spaces, dashes, brackets
 *   - keeps a leading '+' as a country-code marker (wa.me is happy with either digits or digits w/ leading plus stripped)
 *   - if the number has 10 digits and no country prefix, prepend "91" (India) — matches the app's userbase.
 */
export function normalizePhone(raw) {
  if (!raw) return "";
  let s = String(raw).replace(/[\s()\-.]/g, "");
  if (s.startsWith("+")) return s.slice(1); // wa.me wants pure digits
  if (/^0\d{10}$/.test(s)) return "91" + s.slice(1);   // leading 0 domestic prefix
  if (/^\d{10}$/.test(s)) return "91" + s;             // bare 10-digit → assume India
  return s;
}

export function buildWhatsAppUrl(phone, message) {
  const p = normalizePhone(phone);
  const text = encodeURIComponent(message || "");
  return p ? `https://wa.me/${p}?text=${text}` : `https://wa.me/?text=${text}`;
}
